import { call } from '../core'

/**
 * IVibrateParams
 *
 * pattern: [200, 100, 200] → 200ms동안 진동 후 100ms동안 멈춘 후 200ms동안 진동
 */
export interface IVibrateParams {
  pattern: number[]
}

export function vibrate(params: IVibrateParams) {
  call('finVibrate', params)
}
